'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasLiveChatAttachments = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _isEmpty = require('transmute/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _getLiveChatAttachments = require('./getLiveChatAttachments');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasLiveChatAttachments = exports.hasLiveChatAttachments = (0, _pipe2.default)(_getLiveChatAttachments.getLiveChatAttachments, function (attachments) {
  return !(0, _isEmpty2.default)(attachments);
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/hasLiveChatAttachments.js
// module id = 1033
// module chunks = 2 3